import { useQuery } from '@tanstack/react-query';

import { getTicketRequestCategories } from 'api/ticketRequestCategories';
import { RequestQueryKeysE, RequestStaleTimeE } from 'declarations/enums/react-query';
import type { ApiErrorI } from 'declarations/interfaces/errors';
import type { TicketRequestCategoryI } from 'declarations/interfaces/ticketRequestCategories';

export const useFetchTicketRequestCategories = (
  isNewTicketPopupOpened: boolean,
  roofTopId?: string
): ReturnType<typeof useQuery<TicketRequestCategoryI[], ApiErrorI>> => {
  return useQuery<TicketRequestCategoryI[], ApiErrorI>(
    [RequestQueryKeysE.FetchTicketRequestCategories, roofTopId],
    (): Promise<TicketRequestCategoryI[]> => getTicketRequestCategories(roofTopId),
    {
      enabled: isNewTicketPopupOpened && !!roofTopId,
      staleTime: RequestStaleTimeE.TicketRequestCategories,
    }
  );
};
